import React, { Component } from 'react'
import { TABLA_DESCARGA_PROCESADA } from '../../../../../config/tables'
import MuiTable from '../../../../Forms/SharedComponents/containers/MuiTable'

export class TablaDescargaProcesadaEnStockView extends Component {
  render () {
    return (
      <MuiTable id={TABLA_DESCARGA_PROCESADA} />
    )
  }
}
